import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'propertyFieldValue' })
export class PropertyFieldValuePipe implements PipeTransform {
    transform(value: string) {
        if (value.startsWith('#{@') && value.endsWith('@}')) {
            return 'Valor de campo';
        }
        return 'Valor fixo';
    }
}
